@if (isSetupCompleted()) {
<div class="success-container">
  <img
    ngSrc="../../../assets/images/mfa-success.png"
    width="152"
    height="118"
    alt="MFA set up successfully"
    class="illustration"
  />
  <h4 class="bold">
    {{ 'setUpTwoFactor.success.title' | translate }}
  </h4>
  <p>
    {{ 'setUpTwoFactor.success.text' | translate }}
  </p>
</div>
} @else {
<div class="content-container">
  <h3>{{ 'setUpTwoFactor.reminder.title' | translate }}</h3>
  <h4 class="extra-margin">
    {{ 'setUpTwoFactor.reminder.text' | translate }}
  </h4>
  <div class="bullet">
    <mat-icon>check</mat-icon>
    <p>
      {{ 'setUpTwoFactor.reminder.bullet1' | translate }}
    </p>
  </div>
</div>
}
<button
  mat-flat-button
  class="cancel-button"
  color="primary"
  type="submit"
  (click)="onClose()"
>
  {{
    'setUpTwoFactor.' +
      (isSetupCompleted() ? 'success' : 'reminder') +
      '.closeBtn' | translate
  }}
</button>
